import { render } from "./attendance-settings.vue?vue&type=template&id=4e2460a7"
import script from "./attendance-settings.vue?vue&type=script&lang=js"
export * from "./attendance-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__